// @flow

import React from "react";

const Label = ({label}): React$Element<div> => {
  return(
    <div className="line-height-lg bg-purple-600 padding-x-2 text-white font-light font-upper font-sans">
      {label}
    </div>
  )
}

export default Label;
